import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { cleanSearchingMenusPaginated, menuClean } from "../../app/actions/menuActions";

import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsMenus = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewMenus", event: "NewMenus-Clicked" });
    } else if (icon === "list") {
      
      trackEvent({ component: "ListMenus", event: "ListMenus-Clicked" });
      dispatch(cleanSearchingMenusPaginated());
    }

    dispatch(menuClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listMenus" && (
        <Link
          data-tip
          data-for="newMenusTip"
          to="/admin-menu/new-menu"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newMenus" && (
        <Link
          data-tip
          data-for="listMenusTip"
          to="/admin-menu/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editMenus" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listMenusTip"
            to="/admin-menu/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newMenusTip"
            to="/admin-menu/new-menu"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newMenusTip" place="left" effect="solid">
        {t("admin-menu.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listMenusTip" place="left" effect="solid">
        {t("admin-menu.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsMenus;
